export default __webpack_public_path__ + "static/vitro__blanco-d46687700b9294522af266ba74be4d07.png";